/**
 * Copyright 2018 Rex Lee
 *
 * THIS FILE IS PART OF feblog PROJECT
 * ALL COPYRIGHT RESERVED
 *
 * Created by duguying on 2018/6/13.
 */

<template>
  <div class="console" id="terminal"></div>
</template>

<script>
import 'xterm/css/xterm.css'
import { mapMutations } from 'vuex'
import { Terminal } from 'xterm'
import { FitAddon } from 'xterm-addon-fit'
import { AttachAddon } from 'xterm-addon-attach'
import { getToken } from '@/libs/util'
import ring from '@/assets/audios/ping.wav'

export default {
  name: 'XTerm',
  props: {
    terminal: {
      type: Object,
      default: () => {}
    },
    clientId: {
      type: String
    }
  },
  data () {
    return {
      term: null,
      socket: null,
      terminalContainer: null,
      subtitle: '',
      audio: new Audio(ring)
    }
  },
  methods: {
    ...mapMutations([
      'setTagNavSubtitle'
    ]),
    runRealTerminal () {
      console.log('webSocket is finished')
    },
    errorRealTerminal () {
      console.log('error')
    },
    closeRealTerminal () {
      console.log('close')
      window.close()
    },
    // appendBuffer (buffer1, buffer2) {
    //   let tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength)
    //   tmp.set(new Uint8Array(buffer1), 0)
    //   tmp.set(new Uint8Array(buffer2), buffer1.byteLength)
    //   return tmp.buffer
    // },
    handleSocketFailure () {
      this.term.write('Connection failure')
    },
    initSocket () {
      let url = 'wss://api.duguying.net/api/v1/admin/xterm'
      let token = getToken()
      this.socketURI = `${url}?client_id=${this.clientId}&token=${token}`
      this.socket = new WebSocket(this.socketURI)
      this.socketOnClose()
      this.socketOnOpen()
      this.socketOnError()
    },
    socketOnOpen () {
      this.socket.onopen = () => {
        // 链接成功后
        this.initTerm()
      }
    },
    socketOnClose () {
      this.socket.onclose = () => {
        // console.log('close socket')
      }
    },

    socketOnError () {
      this.socket.onerror = () => {
        // console.log('socket 链接失败')
      }
    },
    initTerm () {
      this.term = new Terminal()

      // const decoder = new TextDecoder('utf-8')
      const encoder = new TextEncoder('utf-8')
      // const PIPE = 0x00
      // const RESIZE = 0x01
      const PING = 0x02
      const PONG = 0x03

      console.log('pid : ' + this.terminal.pid + ' is on ready')

      this.terminalContainer = document.getElementById('terminal')

      const attachAddon = new AttachAddon(this.socket)
      const fitAddon = new FitAddon()
      this.term.loadAddon(attachAddon)
      this.term.loadAddon(fitAddon)

      this.term.open(this.terminalContainer)
      this.term.focus()
      fitAddon.fit()
      // fitAddon.activate(this.term)

      this.syncTtySize()
      window.addEventListener('resize', (ev) => {
        let xy = fitAddon.proposeDimensions()
        if (xy.cols > 50 && xy.cols > 24) {
          fitAddon.fit()
        }
      })

      this.term.onData((data) => {
        // console.log(data)
        this.socket.send(encoder.encode('\0' + data))
      })

      this.term.onResize((ev) => {
        this.syncTtySize()
      })

      this.term.onTitleChange((title) => {
        if (title !== this.subtitle) {
          this.setTagNavSubtitle({ route: this.$route, subtitle: title })
          this.subtitle = title
        }
      })

      this.term.onBell(() => {
        console.log('ding!')
        let audio = new Audio(ring)
        audio.play()
      })

      this.socket.addEventListener('message', (ev) => {
        let data = ev.data
        let dataView = new Uint8Array(data)
        dataView.set(data, 0)
        if (dataView[0] === PING) {
          let pong = new Uint8Array(1)
          pong.set([PONG], 0)
          this.socket.send(pong)
        }
      })
    },
    syncTtySize () {
      // const decoder = new TextDecoder('utf-8')
      const encoder = new TextEncoder('utf-8')

      let cols = this.term.cols
      let rows = this.term.rows
      this.socket.send(encoder.encode('\x01' + JSON.stringify({ 'cols': cols, 'rows': rows })))
    }
  },
  mounted () {
    this.initSocket()
  },
  beforeDestroy () {
    this.socket.close()
  }
}
</script>

<style scoped>
#terminal {
  height: 100%;
}
</style>
